<script lang="ts">
	import { makeInflect } from "../../../core/utils/makeInflect.js";
	import { getTranslate } from "../utils/getTranslate.js";
	import translations from "./ReadingTime.translations.json";

	export let minutes: number;
	/** Zkrácená varianta bez slova „čtení“, pro místa s málo prostoru. */
	export let short = false;

	// Nad tímto počtem minut už neuvádíme přesný čas, ale zaokrouhlený údaj („10+ min čtení“), stejně jako na webu Fastest.
	const maxExactMinutes = 10;

	const translate = getTranslate(translations);
	const inflectShort = makeInflect<keyof typeof translations>("minutesOne", "minutesFew", "minutesMany");
	const inflectFull = makeInflect<keyof typeof translations>("minutesReadOne", "minutesReadFew", "minutesReadMany");

	function getKey(count: number, isShort: boolean): keyof typeof translations {
		if (count > maxExactMinutes) {
			return isShort ? "minutesOverLimit" : "minutesReadOverLimit";
		}
		return isShort ? inflectShort(count) : inflectFull(count);
	}

	$: key = getKey(minutes, short);
	$: displayedMinutes = Math.min(minutes, maxExactMinutes);
</script>

{translate(key, { minutes: displayedMinutes })}
